import Sortable from '@stimulus-components/sortable'
import { patch } from '@rails/request.js'

export default class extends Sortable {
  static values = {
    url: String,
  }

  connect() {
    super.connect()
  }

  onUpdate(event) {
    const url = this.urlValue
    const sceneIds = Array.from(
      this.element.querySelectorAll('[data-scene-id]')
    ).map(el => el.dataset.sceneId)

    const formData = new FormData()
    formData.append('scene_ids', sceneIds)

    patch(url, { body: formData, responseKind: 'turbo-stream' })
  }
}
